var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4913 4.69431C14.3505 4.54487 14.1775 4.42518 13.9836 4.3432C13.7897 4.26121 13.5795 4.21879 13.3668 4.21875H9.99963V3.28125C9.99888 2.65987 9.73525 2.06413 9.26657 1.62475C8.79789 1.18536 8.16244 0.938206 7.49963 0.9375C7.40678 0.937493 7.31575 0.961732 7.23676 1.0075C7.15778 1.05327 7.09395 1.11876 7.05243 1.19662L4.69061 5.625H1.99963C1.73451 5.62528 1.48033 5.72415 1.29286 5.8999C1.10539 6.07566 0.999937 6.31395 0.999634 6.5625V11.7188C0.999937 11.9673 1.10539 12.2056 1.29286 12.3813C1.48033 12.5571 1.73451 12.656 1.99963 12.6562H12.6168C12.9823 12.6558 13.335 12.5304 13.609 12.3037C13.883 12.0769 14.0594 11.7643 14.1053 11.4244L14.8553 5.79941C14.8816 5.60155 14.8628 5.4007 14.8 5.21018C14.7373 5.01966 14.6321 4.84382 14.4913 4.69431V4.69431ZM1.99963 6.5625H4.49963V11.7188H1.99963V6.5625Z",
    fill: "#FF6978"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.bc301532b709e44a7c4543d25a5da2d4.svg";
export { ForwardRef as ReactComponent };